import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class CurriculumManagerCatalogDrilldownModel {
	id: number;
	title: string;
	section_count: number;
	program_count: number;
	graduation_plan_count: number;
	student_count: number;
	@Transform(dateTransformer)
	created_date: Date;
	@Transform(dateTransformer)
	last_edited_date: Date;
	@Transform(dateTransformer)
	deactivated_date: Date;
}

export function CurriculumManagerCatalogDrilldownModel_ClassTransform_Type() {
	return CurriculumManagerCatalogDrilldownModel;
}

export class CurriculumManagerCatalogDrilldownResponseModel {
	@Type(CurriculumManagerCatalogDrilldownModel_ClassTransform_Type)
	results: CurriculumManagerCatalogDrilldownModel[];
	count: number;
}

export type CurriculumCatalogDrilldownTypes = 'section' | 'course';
